"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_helpers_1 = require("./data-helpers");
function isDisabled(props) {
    return props.disabled === true;
}
exports.isDisabled = isDisabled;
function isReadOnly(props) {
    return props.readOnly === true;
}
exports.isReadOnly = isReadOnly;
function isDisabledItem(item, props) {
    // TODO: fix any
    return isDisabled(props) || contains(item, props.disabledItems, props.valueField);
}
exports.isDisabledItem = isDisabledItem;
function isReadOnlyItem(item, props) {
    // TODO: fix any
    return isReadOnly(props) || contains(item, props.readOnlyItems, props.valueField);
}
exports.isReadOnlyItem = isReadOnlyItem;
function contains(item, values, valueField) {
    return Array.isArray(values)
        ? values.some(function (value) { return data_helpers_1.valueMatcher(item, value, valueField); })
        : data_helpers_1.valueMatcher(item, values, valueField);
}
exports.contains = contains;
function move(dir, item, props, list) {
    var isDisabledOrReadonly = function (item) { return isDisabledItem(item, props) || isReadOnlyItem(item, props); }, stop = dir === 'next' ? list.last() : list.first(), next = list[dir](item);
    while (next !== stop && isDisabledOrReadonly(next))
        next = list[dir](next);
    return isDisabledOrReadonly(next) ? item : next;
}
exports.move = move;
exports.widgetEnabled = interactionDecorator(true);
exports.widgetEditable = interactionDecorator(false);
function interactionDecorator(disabledOnly) {
    function wrap(method) {
        return function decoratedMethod() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (!(isDisabled(this.props) || (!disabledOnly && isReadOnly(this.props))))
                return method.apply(this, args);
        };
    }
    return function decorate(target, key, desc) {
        if (desc.initializer) {
            var init_1 = desc.initializer;
            desc.initializer = function () { return wrap(init_1()); };
        }
        else
            desc.value = wrap(desc.value);
        return desc;
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/interaction.js
// module id = 69
// module chunks = 0 1 2 3 4 5 6